import React, { useEffect, useState } from 'react';
import { BannerTypesOffice, BreadcrumbServicedOffice, MenuServicedOffice, OtherChoices } from '../common';
import { useTranslation } from 'react-i18next';
import {
  getBanner,
  getBenefits,
  getOfficeInfo,
  getOfficeTypes,
  getServicesOffice,
  getQuestionsOffice,
} from '../servicedOffice.api';
import { getQueryString } from '../../../utils/params';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { BoxGreen } from '../../../assets/images/web-isn';
import { ServicedOfficeContactUs } from '../pages';
import { useParams } from 'react-router-dom';

function TypesWorkStationComponent() {
  const { t } = useTranslation();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { language } = useParams();
  const [officeTypes, setOfficeTypes] = useState();
  // const { currentCurrency } = props.layout;
  const [typeId, setTypeId] = useState();
  const [benefitsInfo, setBenefitsInfo] = useState();
  const [officeId, setOfficeId] = useState(0);
  const [imgOther1, setImgOther1] = useState('');
  const [imgOther2, setImgOther2] = useState('');
  const [imgOther3, setImgOther3] = useState('');
  const [feature, setFeature] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [showContact, setShowContact] = useState(false);
  const dataOtherChoices = [
    {
      title: t('servicedOffice.label_privateRoom'),
      to: `/${language}/serviced-office/types/private-room/`,
      imageUrl: imgOther1,
    },
    {
      title: t('servicedOffice.label_virtualOffices'),
      to: `/${language}/serviced-office/types/virtual-offices/`,
      imageUrl: imgOther2,
    },
    {
      title: t('servicedOffice.label_meetingRoom'),
      to: `/${language}/serviced-office/types/meeting-room/`,
      imageUrl: imgOther3,
    },
  ];

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    showLoader();
    getOfficeInfo(getQueryString({ language })).then(res => {
      if (res) {
        setOfficeId(res[0]?.id);
      }
    });

    if (typeId !== undefined) {
      Promise.all([
        getBenefits(getQueryString({ language, typeId })),
        getServicesOffice(getQueryString({ language, typeId })),
        getQuestionsOffice(getQueryString({ language, typeId })),
      ]).then(values => {
        if (values) {
          setBenefitsInfo(values[0] ?? 0);
          setFeature(values[1] ?? []);
          setQuestions(values[2] ?? []);
        }
        hideLoader();
      });
    }
    //eslint-disable-next-line
  }, [typeId]);

  useEffect(() => {
    if (officeId !== 0) {
      getOfficeTypes(getQueryString({ language, officeId })).then(res => {
        if (res) {
          setOfficeTypes(res[1]);
          setTypeId(res[1]?.id);

          // get image Private Room Other Choices
          getBanner(getQueryString({ language, officeId, typeId: res[0]?.id })).then(data => {
            if (data) {
              setImgOther1(data.images[0].imageUrl);
            }
          });

          // get image Virtual Office Other Choices
          getBanner(getQueryString({ language, officeId, typeId: res[2]?.id })).then(data => {
            if (data) {
              setImgOther2(data.images[0].imageUrl);
            }
          });

          // get image Meeting Room Other Choices
          getBanner(getQueryString({ language, officeId, typeId: res[3]?.id })).then(data => {
            if (data) {
              setImgOther3(data.images[0].imageUrl);
            }
          });
        }
      });
      //eslint-disable-next-line
    }
    hideLoader();
    //eslint-disable-next-line
  }, [officeId]);

  function createMarkup(data) {
    if (data) {
      return { __html: data };
    }
  }

  const handleContactUS = () => {
    setShowContact(true);
  };

  const renderProductInfor = () => {
    if (officeTypes) {
      return (
        <>
          <div className="col-lg-8 col-12 d-block d-lg-none">
            <div className="row">
              <div className="col-12">
                <p className="text-title">{officeTypes?.name}</p>
                <p className="text-description" dangerouslySetInnerHTML={createMarkup(officeTypes?.content)}></p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-12">
            <div className="row ml-0">
              <div className="product-image">
                <LazyLoadImage
                  src={`${process.env.REACT_APP_ISN_IMAGE_URL}${officeTypes?.imageUrl}`}
                  alt=""
                  effect="black-and-white"
                  className="w-100 h-100"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-12 d-lg-block d-none">
            <div className="row">
              <div className="col-12">
                <p className="text-title">{t('servicedOffice.label_workSpace')}</p>
                <p className="text-description" dangerouslySetInnerHTML={createMarkup(officeTypes?.content)}></p>
              </div>
            </div>
          </div>
        </>
      );
    }
  };

  const renderProductFeature = () => {
    if (feature) {
      return (
        <>
          <div className="col-md-8 col-12 offset-md-2 offset-0 text-center">
            <p className="text-title" dangerouslySetInnerHTML={createMarkup(feature[0]?.reasonTitle ? feature[0]?.reasonTitle : '')}></p>
            <p className="text-description" dangerouslySetInnerHTML={createMarkup(feature[0]?.reasonContent ? feature[0]?.reasonContent : '')}></p>
          </div>
          <div className="col-12">
            <div className="row flex justify-content-between">
              {feature &&
                feature.map((el, index) => {
                  return (
                    <div key={`feature${index}`} className="col-12 col-md-4 mb-5 mb-md-0">
                      <div className="card-feature text-center">
                        <LazyLoadImage
                          alt={`gallery${index}`}
                          src={`${process.env.REACT_APP_ISN_IMAGE_URL}${el.imageUrl}`}
                          effect="black-and-white"
                          className="w-100 h-100"
                        />
                        <div className="mt-4 mb-3 titte-feature" dangerouslySetInnerHTML={createMarkup(el.title)}></div>
                        <p className="text-description">{el.content}</p>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </>
      );
    }
  };

  const renderListService = () => {
    return (
      <>
        <div className="col-12 col-md-8 content-service">
          <div className="list-serviced">
            {officeTypes && officeTypes.price ? (
              <div className="title" dangerouslySetInnerHTML={createMarkup(officeTypes?.price)}>
              </div>
            ) : (
              ''
            )}
            {benefitsInfo
              ? benefitsInfo?.map((item, index) => (
                <span className="col-md-6 col-12 name-content align-items-center pb-4" key={index}>
                  <img src={BoxGreen} alt="" />
                  {item.content}
                </span>
              ))
              : ''}
          </div>
        </div>
        <div className="col-12 col-md-4 pr-0 pl-0 img-servide">
          <img
            className="col-12 pr-0 pl-0"
            src={`${process.env.REACT_APP_ISN_IMAGE_URL}${officeTypes?.imageUrl3}`}
            alt=""
          />
        </div>
      </>
    );
  };

  const renderLooking = () => {
    return (
      <>
        <div className="looking-for">
          <div>
            <div className="title">{t('servicedOffice.looking_for')}</div>
            {questions
              ? questions?.map((item, index) => (
                <span className="col-md-6 col-12 name-content align-items-center pb-4" key={index}>
                  <b style={{ color: '#90AF3E' }}>•</b> {item.content}
                </span>
              ))
              : ''}
          </div>
          <div className="d-flex justify-content-center mt-3 mb-4">
            <input
              className="btn-booknow"
              type="button"
              onClick={handleContactUS}
              value={t('detailApartment.contact_us_title')}
            />
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      <BreadcrumbServicedOffice />
      <BannerTypesOffice typeId={typeId} />
      <MenuServicedOffice />
      <ServicedOfficeContactUs
        showLogin={showContact}
        closeLogin={() => {
          setShowContact(false);
        }}
      />
      <div id="typesServiced" className="container">
        <div className="row mb-0 mb-lg-5">{renderProductInfor()}</div>
        <div className="row mt-5">{renderProductFeature()}</div>
        <div className="row mt-5 d-block list-service-show ml-0 mr-0 d-md-flex">{renderListService()}</div>
        {language !== 'jp' ?
          <div className="row mt-5">{renderLooking()}</div>
          : ''}
        <div className="mt-5">
          <OtherChoices dataOtherChoices={dataOtherChoices} />
        </div>
      </div>
      {loader}
    </>
  );
}

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TypesWorkStationComponent);
